import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "team-effectiveness-bar-graph"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "leaderTypeFitGraph row cs-accordion-anchor-child" }
const _hoisted_5 = { class: "leaderTypeFitGraphArea" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"leaderTypeFitCutoff\" style=\"right:0%;\"></div><div class=\"leaderTypeFitCutoff\" style=\"right:25%;\"></div><div class=\"leaderTypeFitCutoff\" style=\"left:50%;\"></div><div class=\"leaderTypeFitCutoff\" style=\"left:25%;\"></div><div class=\"leaderTypeFitCutoff\" style=\"left:0%;\"></div>", 5)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-7 text-xs-center text-sm-left" }
const _hoisted_14 = { class: "col-sm-5 text-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"20px"} }, "Mean Rating:", -1)
const _hoisted_16 = { style: {"font-size":"50px"} }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"leaderTypeFitGraphXAxis\"><div class=\"leaderTypeFitGraphXAxisLabels\"><div class=\"leaderTypeFitGraphXAxisLabel\" style=\"left:75%;width:25%;\"> Strongly <br> agree </div><div class=\"leaderTypeFitGraphXAxisLabel\" style=\"left:50%;width:25%;\">Agree</div><div class=\"leaderTypeFitGraphXAxisLabel\" style=\"left:25%;width:25%;\">Disagree</div><div class=\"leaderTypeFitGraphXAxisLabel\" style=\"left:0%;width:25%;\"> Strongly <br> disagree </div></div></div>", 1)

import { ref, computed, onMounted } from "vue";
import { Tooltip } from "uiv";
import cms from "../../services/cms/cms";
import {
  CmsDocumentTypes,
  CmsTeamEffectivenessReview,
} from "../../services/cms/cms-type-definitions";
import cmsContentMap from "../../services/cms/cms-content-map";
import { TeamEffectivenessReviewApiModel } from "../../api-models";
import { getTeamEffectivenessReport } from "./get-team-effectiveness-report-team-id";

interface TebgRow {
  id: string;
  shortTitle: string;
  content: string;
  min: number;
  mean: number;
  q1: number;
  median: number;
  q3: number;
  max: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-bar-graph',
  props: {
    reviewId: {}
  },
  setup(__props: any) {

function acs(arr: number[]): number[] {
  return arr.sort((a, b) => a - b);
}

function quantile(arr: number[], q: number): number {
  const sorted = acs(arr);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;
  if (sorted[base + 1] !== undefined) {
    return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
  }
  return sorted[base];
}

const props = __props;

const show = ref(true);

const doc = ref<CmsTeamEffectivenessReview | null>(null);

const ter = ref<TeamEffectivenessReviewApiModel | null>(null);

const activeRowId = ref("");

function score(id: string): TebgRow | null {
  if (!ter.value) {
    return null;
  }

  const rawRatings = ter.value.questionnaires.map((x) => x.rawRatings.ratings[id]);
  const max = Math.max(...rawRatings);
  const min = Math.min(...rawRatings);
  const q1 = quantile(rawRatings, 0.25);
  const median = quantile(rawRatings, 0.5);
  const q3 = quantile(rawRatings, 0.75);

  const team = ter.value.aggregateRatings.meanRatings[id];
  const slice = doc.value?.data.body.find((x) => x.primary.question_id === id);

  const row: TebgRow = {
    id,
    shortTitle: cms.asText(slice?.primary.question_short_title),
    content: cms.asText(slice?.primary.question_bar_chart_content),
    min,
    mean: team,
    q1,
    median,
    q3,
    max,
  };
  return row;
}

const rows = computed<(TebgRow | null)[]>(() => {
  if (!ter.value) {
    return [];
  }

  return [
    score("Professional"),
    score("Strategist"),
    score("Practical"),
    score("Servant"),
    score("Executional"),
    score("Transformational"),
    score("Entrepreneurial"),
    score("Charismatic"),
    score("Innovator"),
  ];
});

function click(row: TebgRow | null): void {
  activeRowId.value = row?.id === activeRowId.value ? "" : row?.id ?? "";
}

function bar(start: number, end: number, height: number): string {
  const startValue = start * 10;
  const endValue = end * 10;

  return `position: absolute;
    left: ${startValue}%;
    right: ${endValue}%;
    width: ${endValue - startValue}%;
    border-top-width: ${height}px;
    height: ${height}px;
    top: ${(50 - height) / 2}px;
    `;
}

function square(x: number): string {
  const scaledX = x * 10;
  const size = 40;

  return `position: absolute;
    left: calc(${scaledX}% - ${size / 2}px);
    width: ${size}px;
    background: white;
    border-width: 5px;
    height: ${size}px;
    top: 5px;
    `;
}

function tooltip(row: TebgRow): string {
  return `This team rated ‘${row.shortTitle}’ between ${row.min.toFixed(1)} and ${row.max.toFixed(
    1,
  )} with an average of ${row.mean.toFixed(1)}`;
}

function desc(id: string): string {
  return cms.asText(
    doc.value?.data.body.find((x) => x.primary.question_id.toLowerCase() === id.toLowerCase())
      ?.primary.question_title,
  );
}

onMounted(() => {
  cms
    .getById(
      CmsDocumentTypes.CmsTeamEffectivenessReview,
      cmsContentMap.teamEffectiveness.questionnaireQuestions,
    )
    .then((d) => {
      doc.value = d;
    });

  getTeamEffectivenessReport(props.reviewId).then((data) => {
    ter.value = data;

    // Set the highest rating as active.
    let lowestRating = -1;
    Object.entries(ter.value.aggregateRatings.meanRatings)
      .filter((r) => r[1] > lowestRating)
      .forEach((rating) => {
        [activeRowId.value, lowestRating] = rating;
      });
  });
});

return (_ctx: any,_cache: any) => {
  return (doc.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(row.id),
              key: row.id
            }, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: ($event: any) => (click(row)),
                class: "a-block leaderTypeFitGraphRowAnchor cs-accordion-anchor"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["leaderTypeFitGraphLabel", 'color-' + row.id.toLowerCase()]),
                    style: {"line-height":"1","display":"flex","align-items":"center"}
                  }, [
                    _createElementVNode("div", null, _toDisplayString(row.shortTitle), 1)
                  ], 2),
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_unref(Tooltip), {
                      text: tooltip(row)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["leaderTypeGraphBar", 'btn-' + row.id.toLowerCase()]),
                          style: _normalizeStyle(bar(row.min, row.max, 5))
                        }, null, 6)
                      ]),
                      _: 2
                    }, 1032, ["text"]),
                    _createVNode(_unref(Tooltip), {
                      text: tooltip(row)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["leaderTypeGraphBar", 'btn-' + row.id.toLowerCase()]),
                          style: _normalizeStyle(square(row.mean))
                        }, null, 6)
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ])
                ])
              ], 8, _hoisted_3),
              _createElementVNode("div", {
                class: _normalizeClass([{ hidden: row.id !== activeRowId.value }, "leaderTypeFitGraphInfo cs-accordion-panel"])
              }, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(row.content), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("p", _hoisted_16, _toDisplayString(row.mean.toFixed(1)), 1)
                  ])
                ])
              ], 2)
            ], 2))
          }), 128)),
          _hoisted_17
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})